<template>
  <SvoiLoader v-bind="$props" class="loader-wrapper" :style="{ width }" />
</template>

<script lang="ts">
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import type { Sizes } from '@svoi-ui/interfaces/loader'
import { SvoiLoader } from '@svoi-ui/components/loader'

export default defineComponent({
  name: 'BaseLoaderWrapper',
  components: { SvoiLoader },
  props: {
    label: {
      type: String,
      default: undefined,
    },
    size: {
      type: String as PropType<Sizes | string>,
      default: undefined,
    },
    width: {
      type: String,
      default: undefined,
    },
  },
})
</script>

<style lang="scss" scoped>
.loader-wrapper {
  background: $color-default-white;
  border-radius: 24px;
  padding: 32px;
  width: 100%;
}
</style>
